import React from 'react';

import { Book } from '../../../models/books';

import BookElectionSearch from './BookElectionSearch';
import RemoveSelectedBook from './RemoveSelectedBook';
import BookElectionList from './BookElectionList';
import SelectedBook from './SelectedBook';

const BookCandidate = ({ 
  selectedBooks, 
  booksSearchResults,
  index, 
  setBooksSearchResults,
  selectedBook,
  addItemToSelectedBooks
}) => {
  return (
    <div style={{ position: 'relative' }}>
      <BookElectionSearch
        selectedBook={selectedBook}
        setBooksSearchResults={setBooksSearchResults}
      />
      {/* {selectedBook && (
                              <RemoveSelectedBook
                                selectedBooks={selectedBooks}
                                searchBooks={booksSearchResults}
                                setBooksSearchResults={setBooksSearchResults}
                                field={field}
                                index={index}
                                remove={remove}
                                setBooksSelected={setSelectedBooks}
                              />
                            )} */}
      {!selectedBook
        ? (
          <BookElectionList
            booksSearchResults={booksSearchResults}
            onChange={(book: Book) =>
              addItemToSelectedBooks(book, index)
            } />
        ) : null
      }
      <SelectedBook
        selectedBook={selectedBook}
      />
    </div>
  )
}

export default BookCandidate;